import {
  Button,
  EditIcon,
  Flex,
  Loader,
  Tooltip,
  TrashCanIcon,
} from "@fluentui/react-northstar";
import React, { useState } from "react";
import styled from "styled-components";
import UpdateSkillBridgeModel from "../UpdateSkillBridgeModel";
import DeleteSkillBridgeModel from "../DeleteSkillBridgeModel";
import { useTranslation } from "react-i18next";
import "./SkillBridgeTable.scss";

const Card = styled(Flex)`
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  padding: 20px;
  border-radius: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

const SkillBridgeTable = (props) => {
  const [itemDetails, setItemDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "Ministry",
    is_active: true,
  });
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isOpenUpdateItem, setIsOpenUpdateItem] = useState(false);
  const [isOpenDeleteItem, setIsOpenDeleteItem] = useState(false);

  const { t } = useTranslation();
  const { listHeaders } = props;

  return (
    <>
      <UpdateSkillBridgeModel
        itemDetails={itemDetails}
        setItemDetails={setItemDetails}
        isOpen={isOpenUpdateItem}
        getAllSkillBridgeData={props.getAllSkillBridgeData}
        user={props.user}
        onClose={() => {
          setIsOpenUpdateItem(false);
        }}
      />
      <DeleteSkillBridgeModel
        isOpen={isOpenDeleteItem}
        getAllSkillBridgeData={props.getAllSkillBridgeData}
        itemToDelete={itemToDelete}
        setItemToDelete={setItemToDelete}
        user={props.user}
        onClose={() => {
          setIsOpenDeleteItem(false);
        }}
      />
      <Flex column>
        <div style={{ padding: "0 20px 20px" }}>
          <Card className="ms-Grid-row my-3">
            <div className="ms-Grid-col ms-sm12 ms-lg2">{listHeaders.name}</div>
            <div className="ms-Grid-col ms-sm12 ms-lg2">
              {listHeaders.email}
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg2">{listHeaders.role}</div>
            <div className="ms-Grid-col ms-sm12 ms-lg2">
              {listHeaders.is_active}
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg2 text-right pr-3">
              {listHeaders.actions}
            </div>
          </Card>
        </div>
        <div
          style={{ padding: "0 20px 20px" }}
          className="skillbridge-lists-wrapper"
        >
          {props.isLoading ? (
            <Flex
              hAlign="center"
              vAlign="center"
              style={{ height: "150px", width: "100%" }}
            >
              <Loader />
            </Flex>
          ) : props.data.length ? (
            props.data.map((item, i) => {
              const fullName = `${item.firstName || ""} ${
                item.lastName || ""
              }`.trim();
              const role = item.role;
              const isActive = Boolean(item.is_active);
              return (
                <Card className="ms-Grid-row my-3" key={item.userID || i}>
                  <div className="ms-Grid-col ms-sm12 ms-lg2">
                    <Tooltip
                      content={fullName}
                      trigger={
                        <p className="skillbridge-info-text">
                          {fullName || "-"}
                        </p>
                      }
                    />
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg2">
                    <Tooltip
                      content={item.email}
                      trigger={
                        <p className="skillbridge-info-text">
                          {item.email || "-"}
                        </p>
                      }
                    />
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg2">
                    <Flex
                      style={{
                        width: "80px",
                        height: "25px",
                        padding: "3px 8px",
                        textAlign: "center",
                        borderRadius: "13px",
                        color: "white",
                        alignSelf: "center",
                        backgroundColor:
                          role === "Ministry" ? "#6264a7" : "#0078d4",
                        fontSize: "12px",
                      }}
                      hAlign="center"
                      vAlign="center"
                    >
                      {role}
                    </Flex>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg2">
                    <Flex
                      style={{
                        width: "70px",
                        height: "25px",
                        padding: "3px 0",
                        textAlign: "center",
                        borderRadius: "13px",
                        color: "white",
                        alignSelf: "center",
                        backgroundColor: isActive ? "#1dc344" : "#ff5000",
                      }}
                      hAlign="center"
                      vAlign="center"
                    >
                      {isActive ? "Active" : "Inactive"}
                    </Flex>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg2 text-right pr-3">
                    <Flex gap="gap.smaller">
                      <Button
                        iconOnly
                        icon={<EditIcon />}
                        onClick={() => {
                          const details = {
                            userID: item.userID,
                            firstName: item.firstName,
                            lastName: item.lastName,
                            email: item.email,
                            role: item.role,
                            is_active: item.is_active,
                          };
                          setItemDetails(details);
                          setIsOpenUpdateItem(true);
                        }}
                      />
                      <Button
                        iconOnly
                        icon={<TrashCanIcon />}
                        onClick={() => {
                          setItemToDelete(item);
                          setIsOpenDeleteItem(true);
                        }}
                      />
                    </Flex>
                  </div>
                </Card>
              );
            })
          ) : (
            <Flex
              hAlign="center"
              vAlign="center"
              style={{ height: "150px", width: "100%" }}
            >
              <p>No data found</p>
            </Flex>
          )}
        </div>
      </Flex>
    </>
  );
};

export default SkillBridgeTable;
